export enum OrderColors {
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
}

export enum OrderColorHex {
  GREEN = '#1A7028',
  YELLOW = '#826819',
  RED = '#C3352B',
}

export enum TurboColor {
  RED = 'RED',
  YELLOW = 'YELLOW',
}

export const TURBO_COLORS: { [color in TurboColor]: string } = {
  [TurboColor.RED]: 'var(--primitive-solid-red-70)',
  [TurboColor.YELLOW]: 'var(--flavor-70)',
}

export enum CLIENT_EDIT_PREFERENCE {
  REPLACE_ITEM = 1,
  ASK_CLIENT = 2,
  DELETE_ITEM = 3,
}
